PJQ.views.dailyReports.DailyReportsNavigator = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DAILYREPORTS, 'Daily-Reports-Navigator'),
        subTemplates: {
            dailyReportDay: new PJQ.templating.Template(PJQ.constants.modules.DAILYREPORTS, 'Daily-Report-Day')
        }
    },
    events: {
        'click .daily-report-prev-day': 'previousDay',
        'click .daily-report-next-day': 'nextDay',
        'click .btn-daily-report-day-off': 'setDayOff',
        'click .btn-daily-report-work-day': 'setWorkDay',
        'click .btn-daily-report-submit': 'submitReport',
        'click .btn-daily-report-share': 'share',
        'shown.bs.tab .daily-report-nav-bar': 'tabChanged',
        'click .btn-daily-report-export-all': 'exportAll',
        'click .btn-daily-report-export-report': 'exportReportOnly',
        'click .btn-daily-report-export-attachments': 'exportAttachments',
        'click .btn-daily-report-settings': 'viewSettings',
        'click .btn-daily-report-export-expenses': 'exportExpenses',
        'click .btn-daily-report-export-expenses-excel': 'exportExpensesExcel',
        'click .btn-daily-report-export-all-zip': 'exportAll',
        'click .btn-daily-report-remove-submit': 'removeSubmit',
        'click .btn-daily-report-export-submitted': 'exportAllSubmittedZip',
        'click .btn-daily-report-export-weekly': 'exportWeeklyReport',
        'click .btn-daily-report-log-delays': 'logDelays'
    },
    beforeFirstRender: function () {
        this.hideUnsubmit = PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.HIDE_DAILY_REPORT_UNSUBMIT);
        if (this.options.date == null) {
            this.options.date = new Date();
        }

        if (this.model == null) {
            this.model = new PJQ.models.dailyReports.DailyReport({
                reportDate: this.options.date,
                projectId: this.options.project.id
            });
        }
        this.model.fetch();
    },
    beforeRender: function () {
        this.renderData = {
            model: this.model,
            project: this.options.project,
            hideUnsubmit: this.hideUnsubmit
        };
    },
    afterRender: function () {
        this.calendar = new PJQ.views.calendars.MiniCalendar({
            el: this.$('.daily-report-mini-calendar'),
            datepickerOptions: {
                defaultDate: this.options.date
            },
            onChange: _.bind(this.goToDate, this),
            dateRangeChanged: _.bind(function (range) {
                this.renderCalendarStatuses(range);
            }, this)
        });

        if (this.model.id > 0) {
            this.renderDay();
        } else {
            this.listenTo(this.model, 'sync', this.renderDay);
        }
    },
    renderCalendarStatuses: function (range) {
        if (range == null) {
            if (this.calendar == null) {
                return;
            }
            range = this.calendar.getCurrentDateRange();
        }

        let rangeCollection = new PJQ.collections.dailyReports.DailyReports(null, {
            project: this.options.project,
            startDate: range.start,
            endDate: range.end
        });
        rangeCollection.fetch({
            success: _.bind(function () {
                let dates = _.map(rangeCollection.models, function (model) {
                    return {
                        date: model.get('reportDate'),
                        color: model.get('status') === 0 ? null : model.getStatusColor(),
                        textColor: model.get('wasDelayed') ? '#de5a73' : null
                    };
                });
                this.calendar.renderStatusMarkers(dates);
            }, this)
        });
    },
    renderDay: function () {
        this.renderSubTemplate(false, this.options.subTemplates.dailyReportDay, this.$('.daily-report-content'), {
            model: this.model,
            project: this.options.project,
            activeTab: this.options.tab
        });

        let $nav = this.$('.daily-report-nav-bar');
        if (_.size(this.activeTab) > 0) {
            $nav.find('.nav-item>.nav-link[href="' + this.activeTab + '"]').tab('show');
        } else {
            this.activeTab = $nav.find('.nav-item>.nav-link.active').attr('href');
        }

        this.renderStatus();

        this.renderWeather();

        if (this.options.project.hasPermission('dailyReports.canViewWorkLogs')) {
            if (this.workLogManagementView != null) {
                this.workLogManagementView.remove();
            }
            this.workLogManagementView = new PJQ.views.dailyReports.WorkLogManagement({
                el: this.$('#workLogsContainer'),
                collection: this.model.workLogs,
                project: this.options.project,
                dailyReport: this.model
            });
            this.model.workLogs.on('update', _.bind(function () {
                this.$('.badge-work-logs').html(this.model.workLogs.length);
            }, this));
        }

        if (this.options.project.hasPermission('dailyReports.canViewNotes')) {
            if (this.noteManagementView != null) {
                this.noteManagementView.remove();
            }
            this.noteManagementView = new PJQ.views.dailyReports.NoteManagement({
                el: this.$('#notesContainer'),
                collection: this.model.notes,
                project: this.options.project,
                dailyReport: this.model
            });
            this.model.notes.on('update', _.bind(function () {
                this.$('.badge-notes').html(this.model.notes.length);
            }, this));
        }
        if (this.options.project.hasPermission('dailyReports.canViewExpenses') && !this.options.project.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_DAILY_REPORT_EXPENSES)) {
            if (this.expenseManagementView != null) {
                this.expenseManagementView.remove();
            }
            this.expenseManagementView = new PJQ.views.dailyReports.ExpenseManagement({
                el: this.$('#expensesContainer'),
                collection: this.model.expenses,
                project: this.options.project,
                dailyReport: this.model
            });
            this.model.expenses.on('update', _.bind(function () {
                this.$('.badge-expenses').html(this.model.expenses.length);
            }, this));
        }

        if (this.options.project.hasPermission('dailyReports.canViewDeliveries')) {
            if (this.deliveryManagementView != null) {
                this.deliveryManagementView.remove();
            }
            this.deliveryManagementView = new PJQ.views.dailyReports.DeliveryManagement({
                el: this.$('#deliveryContainer'),
                collection: this.model.deliveries,
                project: this.options.project,
                dailyReport: this.model
            });
            this.model.deliveries.on('update', _.bind(function () {
                this.$('.badge-deliveries').html(this.model.deliveries.length);
            }, this));
        }

        if (this.options.project.hasPermission('dailyReports.canViewCommunicationLogs')) {
            if (this.communicationLogManagementView != null) {
                this.communicationLogManagementView.remove();
            }
            this.communicationLogManagementView = new PJQ.views.dailyReports.CommunicationLogManagement({
                el: this.$('#communicationLogContainer'),
                collection: this.model.communicationLogs,
                project: this.options.project,
                dailyReport: this.model
            });
            this.model.communicationLogs.on('update', _.bind(function () {
                this.$('.badge-communication-logs').html(this.model.communicationLogs.length);
            }, this));
        }

        if (this.options.project.hasPermission('dailyReports.canViewInspectionLogs')) {
            if (this.inspectionLogManagementView != null) {
                this.inspectionLogManagementView.remove();
            }
            this.inspectionLogManagementView = new PJQ.views.dailyReports.InspectionLogManagement({
                el: this.$('#inspectionLogContainer'),
                collection: this.model.inspectionLogs,
                project: this.options.project,
                dailyReport: this.model
            });
            this.model.inspectionLogs.on('update', _.bind(function () {
                this.$('.badge-inspection-logs').html(this.model.inspectionLogs.length);
            }, this));
        }

        if (this.options.project.hasPermission('dailyReports.canViewAttachments')) {
            if (this.attachmentManagementView != null) {
                this.attachmentManagementView.remove();
            }
            this.attachmentManagementView = new PJQ.views.dailyReports.AttachmentManagement({
                el: this.$('#attachmentsContainer'),
                project: this.options.project,
                model: this.model
            });
            this.model.attachments.on('update', _.bind(function () {
                this.$('.badge-attachments').html(this.model.attachments.length);
            }, this));
        }

        if (this.options.project.hasPermission('dailyReports.canViewSurvey')) {
            if (this.surveyView != null) {
                this.surveyView.remove();
            }
            this.surveyView = new PJQ.views.dailyReports.Survey({
                el: this.$('#surveyContainer'),
                project: this.options.project,
                model: this.model
            });
            this.model.surveyItems.on('change', _.bind(function () {
                this.$('.badge-survey').html(_.size(this.model.surveyItems.getCompletedItems()));
            }, this));
        }

        if (this.loader != null) {
            this.loader.remove();
            this.loader = null;
        }
    },
    renderStatus: function () {
        let bgColor = '#9E9E9E',
            statusName = "Loading...";
        if (this.model != null && this.model.id > 0) {
            if (this.model.get('status') !== 0) {
                this.calendar.updateStatusMarker({
                    date: this.model.get('reportDate'),
                    color: this.model.getStatusColor(),
                    textColor: this.model.get('wasDelayed') ? '#de5a73' : null
                });
            }

            let exportButton = this.$('.btn-daily-report-export-outer'),
                shareButton = this.$('.btn-daily-report-share-outer'),
                dayOffButton = this.$('.btn-daily-report-day-off-outer'),
                workDayButton = this.$('.btn-daily-report-work-day-outer'),
                submitButton = this.$('.btn-daily-report-submit-outer'),
                logDelaysButton = this.$('.btn-daily-report-log-delays-outer'),
                removeSubmitButton = this.$('.btn-daily-report-remove-submit-outer');
            if (this.model.get('status') === 1) {
                exportButton.add(shareButton).removeClass('hidden');
                if(!this.hideUnsubmit) {
                    removeSubmitButton.add().removeClass('hidden');
                }
                submitButton.add(dayOffButton).addClass('hidden');
                logDelaysButton.addClass('hidden');
            } else {
                exportButton.removeClass('hidden');
                shareButton.addClass('hidden');
                logDelaysButton.removeClass('hidden');
                if(!this.hideUnsubmit) {
                    removeSubmitButton.add().addClass('hidden');
                }
                submitButton.removeClass('hidden');
                if (this.model.get('status') === 2) {
                    dayOffButton.addClass('hidden');
                    workDayButton.removeClass('hidden');
                } else {
                    workDayButton.addClass('hidden');
                    dayOffButton.removeClass('hidden');
                }
            }
            this.$('.daily-report-buttons').removeClass('invisible');

            bgColor = this.model.getStatusColor();
            statusName = this.model.getStatusName();
        }
        this.$('.daily-report-status').html($('<div>', {
            class: 'text-light text-align-center fs-16 font-weight-light',
            style: 'background-color:' + bgColor
        }).html(statusName));
    },
    removeSubmit: function () {
        new PJQ.views.modals.YesNo({
            header: "Remove Submission?",
            body: "Are you sure you would like to remove submission?",
            onYes: _.bind(function () {
                if (this.model.get('status') === 1) {
                    this.model.set('status', 0);
                }
                this.model.save(null, {
                    success: _.bind(function () {
                        this.render();
                        PJQ.notifications.notify.successNotify({
                            message: 'Successfully Removed Submission!'
                        });
                    }, this)
                })
            }, this)
        });
    },
    renderWeather: function () {
        if (this.model == null || this.model.isNew()) {
            this.$('.weather, .weather-error').addClass('hidden');
        } else {
            let weather = this.model.weather;
            if (weather != null && !weather.isNew()) {
                this.$('.weather-condition-icon').attr('src', weather.conditionIconUrl());
                this.$('.weather-min-temp').html(weather.minTempDisplay());
                this.$('.weather-max-temp').html(weather.maxTempDisplay());
                this.$('.weather-condition').html(weather.get('condition'));
                this.$('.weather').removeClass('hidden');
                this.$('.weather-error').addClass('hidden');
            } else {
                this.$('.weather').addClass('hidden');
                let error = null;
                if (PJQ.helpers.dateHelpers.getDateDiff(this.model.get('reportDate'), new Date(), 'days') + 1 >= PJQ.constants.weather.MAX_FORECAST_DAYS) {
                    error = $("<div>", {
                        class: "m-3"
                    }).html("Weather forecast is limited to 14 days");
                } else {
                    error = $("<div>", {
                        class: "m-1"
                    }).html("Unable to get weather information.  Make sure the project zip code is valid!");
                }
                this.$('.weather-error').html(error);
                this.$('.weather-error').removeClass('hidden');
            }
        }
    },
    tabChanged: function (e) {
        this.activeTab = $(e.target).attr('href');
        switch (this.activeTab) {
            case '#workLogsContainer':
                if (this.workLogManagementView != null && this.workLogManagementView.dataTable != null) {
                    this.workLogManagementView.dataTable.adjust();
                }
                break;
            case '#notesContainer':
                if (this.noteManagementView != null && this.noteManagementView.dataTable != null) {
                    this.noteManagementView.dataTable.adjust();
                }
                break;
            case '#expensesContainer':
                if (this.expenseManagementView != null && this.expenseManagementView.dataTable != null) {
                    this.expenseManagementView.dataTable.adjust();
                }
                break;
            case '#deliveryContainer':
                if (this.deliveryManagementView != null && this.deliveryManagementView.dataTable != null) {
                    this.deliveryManagementView.dataTable.adjust();
                }
                break;
        }
    },
    previousDay: function () {
        this.goToDate(this.model.get('reportDate').addDays(-1));
    },
    nextDay: function () {
        this.goToDate(this.model.get('reportDate').addDays(1));
    },
    goToDate: function (date) {
        this.options.date = date;

        //Keep route up to date
        PJQ.app.router.navigate('projects/' + PJQ.app.session.project.id + '/dailyreports/' + PJQ.helpers.dateHelpers.getDateString(this.options.date, PJQ.helpers.dateHelpers.dateFormats.URL_DATE), {
            trigger: false
        });

        this.loader = new PJQ.Loader(this.$('.daily-report-container'));
        this.model = null;
        this.renderWeather();
        this.renderStatus();
        this.$('.daily-report-buttons').addClass('invisible');
        this.$('.daily-report-date').html(PJQ.helpers.dateHelpers.getDateString(date, 'MM/dd/yyyy'));
        this.calendar.setDate(date);

        this.model = new PJQ.models.dailyReports.DailyReport({
            reportDate: date,
            projectId: this.options.project.id
        });
        this.listenTo(this.model, 'sync', this.renderDay);
        this.model.fetch();
    },
    setDayOff: function () {
        this.model.patch({
            status: PJQ.constants.dailyReports.statuses.DAY_OFF
        }, {
            success: _.bind(function () {
                this.renderStatus();
            }, this)
        });
    },
    setWorkDay: function () {
        this.model.patch({
            status: PJQ.constants.dailyReports.statuses.NOT_SUBMITTED
        }, {
            success: _.bind(function () {
                this.renderStatus();
            }, this)
        });
    },
    validateReport: function () {
        let isValid = this.surveyView.validate();
        if (this.surveyAlert != null) {
            this.surveyAlert.destroy();
        }
        if (!isValid) {
            this.$('.survey-tab').tab('show');
            this.surveyAlert = new PJQ.Alert(this.$('.daily-report-survey'), {
                type: 'danger',
                text: 'Required survey items are not complete',
                isPrepend: true
            });
        }
        return isValid;
    },
    submitReport: function () {
        if (this.validateReport()) {
            new PJQ.views.signatures.SignatureSubmitModal({
                onSubmit: _.bind(function (signature, callback) {
                    this.model.submit(signature, _.bind(function () {
                        this.renderStatus();
                        this.render();
                        callback();
                    }, this));
                }, this)
            });
        }
    },
    exportReportOnly: function () {
        new PJQ.views.dailyReports.DailyReportExportSettingsModal({
            dailyReport: this.model,
            onSave: _.bind(function (model) {
                this.exportReport(null, model)
            }, this)
        });
    },
    exportAll: function () {
        new PJQ.views.dailyReports.DailyReportExportSettingsModal({
            dailyReport: this.model,
            onSave: _.bind(function (model) {
                this.exportReport('all', model)
            }, this)
        });
    },
    exportAttachments: function () {
        new PJQ.views.dailyReports.DailyReportExportSettingsModal({
            dailyReport: this.model,
            onSave: _.bind(function (model) {
                this.exportReport('attachments', model)
            }, this)
        });
    },
    exportReport: function (mode, settings) {
        let loader = new PJQ.Loader(this.$('.btn-daily-report-export'), {
            loadingText: "Exporting..."
        });
        this.model.exportReport(mode, true, settings, function () {
            loader.remove();
        });
    },
    exportAllSubmittedZip: function () {
        let loader = new PJQ.Loader(this.$('.btn-reports'), {
            loadingText: "Exporting..."
        });
        new PJQ.ajax.Request({
            endpoint: this.options.project.endpoint(false) + '/dailyreports/export/submitted',
            isApi2: true
        }).post().done(_.bind(function (response) {
            PJQ.files.handleDownload(response);
            loader.remove();
        }, this)).fail(_.bind(function (xhr, err, result) {
            PJQ.notifications.notify.errorNotify({
                message: 'An error has occurred.'
            });
            loader.remove();
        }, this));
    },
    exportReportsZipByDate: function () {
        new PJQ.views.reporting.GenerateReportModal({
            model: new PJQ.models.reporting.Report({
                id: 'reports',
                name: 'Reports',
                options: [
                    {
                        id: _.unique(),
                        type: 'DATE_RANGE',
                        name: 'Dates',
                        isRequired: true,
                        defaultValue: {
                            from: PJQ.helpers.dateHelpers.getNewDateAddDays(new Date(), -7),
                            to: new Date()
                        },
                        value: {
                            from: PJQ.helpers.dateHelpers.getNewDateAddDays(new Date(), -7),
                            to: new Date()
                        }
                    }
                ]
            }),
            onDownload: _.bind(function (options, callback) {
                new PJQ.ajax.Request({
                    endpoint: this.options.project.endpoint(false) + '/dailyreports/export/date',
                    data: {
                        options: options,
                        isApi2: true
                    }
                }).post().done(_.bind(function (response) {
                    PJQ.files.downloadFile(response.url, {
                        isEndpoint: false
                    });
                    callback();
                }, this)).fail(_.bind(function (xhr, err, result) {
                    callback();
                }, this));
            }, this)
        });
    },
    exportExpensesExcel: function () {
        new PJQ.views.reporting.GenerateReportModal({
            model: new PJQ.models.reporting.Report({
                id: 'expenses',
                name: 'Expenses',
                options: [
                    {
                        id: _.unique(),
                        type: 'DATE_RANGE',
                        name: 'Dates',
                        isRequired: true,
                        defaultValue: {
                            from: PJQ.helpers.dateHelpers.getNewDateAddDays(new Date(), -7),
                            to: new Date()
                        },
                        value: {
                            from: PJQ.helpers.dateHelpers.getNewDateAddDays(new Date(), -7),
                            to: new Date()
                        }
                    }
                ]
            }),
            onDownload: _.bind(function (options, callback) {
                new PJQ.ajax.Request({
                    endpoint: this.options.project.endpoint(false) + '/dailyreports/reports/expenses/excel',
                    data: {
                        options: options,
                        isApi2: true
                    }
                }).post().done(_.bind(function (response) {
                    PJQ.files.downloadFile(response.url, {
                        isEndpoint: false
                    });
                    callback();
                }, this)).fail(_.bind(function (xhr, err, result) {
                    callback();
                }, this));
            }, this)
        });
    },
    exportExpenses: function () {
        new PJQ.views.reporting.GenerateReportModal({
            model: new PJQ.models.reporting.Report({
                id: 'expenses',
                name: 'Expenses',
                options: [
                    {
                        id: _.unique(),
                        type: 'DATE_RANGE',
                        name: 'Dates',
                        isRequired: true,
                        defaultValue: {
                            from: PJQ.helpers.dateHelpers.getNewDateAddDays(new Date(), -7),
                            to: new Date()
                        },
                        value: {
                            from: PJQ.helpers.dateHelpers.getNewDateAddDays(new Date(), -7),
                            to: new Date()
                        }
                    }
                ]
            }),
            onDownload: _.bind(function (options, callback) {
                new PJQ.ajax.Request({
                    endpoint: this.options.project.endpoint(false) + '/dailyreports/reports/expenses',
                    data: {
                        options: options,
                        isApi2: true
                    }
                }).post().done(_.bind(function (response) {
                    PJQ.files.downloadFile(response.url, {
                        isEndpoint: false
                    });
                    callback();
                }, this)).fail(_.bind(function (xhr, err, result) {
                    callback();
                }, this));
            }, this)
        });
    },
    exportWeeklyReport: function () {
        new PJQ.views.dailyReports.DailyReportWeeklyExportModal({
            model: new PJQ.models.reporting.Report({
                id: 'weekly',
                name: 'Weekly',
                options: [
                    {
                        id: _.unique(),
                        type: 'DATE_RANGE',
                        name: 'Dates',
                        isRequired: true,
                        defaultValue: {
                            from: PJQ.helpers.dateHelpers.getNewDateAddDays(new Date(), -6),
                            to: new Date()
                        },
                        value: {
                            from: PJQ.helpers.dateHelpers.getNewDateAddDays(new Date(), -7),
                            to: new Date()
                        }
                    }
                ]
            }),
            onDownload: _.bind(function (options, callback) {
                new PJQ.ajax.Request({
                    endpoint: this.options.project.endpoint(false) + '/dailyreports/export/weekly',
                    data: {
                        options: options,
                        isApi2: true
                    }
                }).post().done(_.bind(function (response) {
                    PJQ.files.downloadFile(response.url, {
                        isEndpoint: false
                    });
                    callback();
                }, this)).fail(_.bind(function (xhr, err, result) {
                    callback();
                }, this));
            }, this)
        })
    },
    share: function () {
        let sharingModal = new PJQ.views.sharing.SharingModal({
            project: this.options.project,
            subject: 'A Daily Report has been shared with you',
            onSave: _.bind(function (data) {
                this.model.share(data, _.bind(function (url) {
                    PJQ.notifications.notify.successNotify({
                        message: 'Daily Report share email sent'
                    });
                }, this));
            }, this)
        });
        this.model.exportReport(null, false, null, _.bind(sharingModal.urlChanged, sharingModal));
    },
    viewSettings: function () {
        new PJQ.views.dailyReports.DailyReportSettingsModal({
            project: this.options.project,
            onSave: _.bind(function () {
                this.renderCalendarStatuses();
                this.model.fetch({
                    success: _.bind(function () {
                        this.renderDay();
                    }, this)
                });
            }, this)
        });
    },
    logDelays: function () {
        new PJQ.views.dailyReports.DailyReportLogDelaysModal({
            model: this.model,
            onSave: () => {
                this.renderCalendarStatuses();
            }
        });
    }
});

PJQ.views.dailyReports.DailyReportWeeklyExportModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DAILYREPORTS, 'Modal-Daily-Report-Weekly-Export'),
        subTemplates: {
            exportWeek: new PJQ.templating.Template(PJQ.constants.modules.DAILYREPORTS, 'weekly-export-week'),
        },
        maxWidth: 600,
        onSave: _.noop
    },
    events: {
        'click .weekly-export': 'exportWeekly',
        'click .week-div': 'weekSelected'
    },
    beforeRender: function () {
    },
    renderData: function () {
        return {
            setDefaultValues: true,
            today: new Date(),
            months: ["January", "February", "March", "April", "May", "June", "July",
                "August", "September", "October", "November", "December"],
            model: this.model,
            settings: null
        };
    },
    afterRender: function () {
        let today = new Date();
        this.monthPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.input-select-month'),
            defaultValue: today.getMonth(),
            isIntChoices: true,
            onChange: _.bind(function (value) {
                this.renderWeeks(value, this.yearPicker.getValue());
            }, this)
        });
        this.yearPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.input-select-year'),
            defaultValue: today.getFullYear(),
            isIntChoices: true,
            onChange: _.bind(function (value) {
                this.renderWeeks();
            }, this)
        });
        this.startDayPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.input-select-start-day'),
            defaultValue: today.getDay(),
            isIntChoices: true,
            onChange: _.bind(function (value) {
                this.renderWeeks();
            }, this)
        });
        this.renderWeeks();
    },
    getWeeks: function () {
        let m = this.monthPicker.getValue(),
            y = this.yearPicker.getValue(),
            sd = this.startDayPicker.getValue(),
            d = new Date();
        d.setYear(y)
        d.setMonth(m);
        d.setDate(1);

        let month = d.getMonth(),
            result = [];
        // Get the first "startDay" in the month
        while (d.getDay() !== sd) {
            d.setDate(d.getDate() + 1);
        }

        // Get all the other "startDays" in the month
        while (d.getMonth() === month) {
            result.push(new Date(d.getTime()));
            d.setDate(d.getDate() + 7);
        }

        return result;
    },
    renderWeeks: function () {
        this.setSelectedWeek(null);
        this.weeks = this.getWeeks();

        let $choices = this.$('.week-choices-container');
        $choices.empty();
        _.each(this.weeks, function (week, ix) {
            this.renderSubTemplate(true, this.options.subTemplates.exportWeek, $choices, {
                weekNumber: ix,
                dates: PJQ.helpers.dateHelpers.getDateString(week, PJQ.helpers.dateHelpers.dateFormats.DATE) + ' - ' + PJQ.helpers.dateHelpers.getDateString(PJQ.helpers.dateHelpers.getNewDateAddDays(week, 6), PJQ.helpers.dateHelpers.dateFormats.DATE)
            });
        }, this);
    },
    weekSelected: function (e) {
        this.$('.weekly-export').attr('disabled', false);

        let $target = $(e.currentTarget);
        this.setSelectedWeek($target.data().week)
    },
    setSelectedWeek: function (week) {
        this.selectedWeek = week;

        this.$el.find('.week-div').removeClass('week-select');
        this.$el.find('.select-week').removeClass('fa-check-square').addClass('fa-square');
        this.$('.weekly-export').attr('disabled', this.selectedWeek == null);
        if (this.selectedWeek != null) {
            let $selected = this.$('.week-div[data-week="' + this.selectedWeek + '"]')
            $selected.addClass('week-select');
            $selected.find('.select-week').removeClass('fa-square').addClass('fa-check-square');
        }
    },
    exportWeekly: function () {
        if (this.selectedWeek == null) {
            return;
        }

        let weekObj = this.weeks[this.selectedWeek],
            startDay = PJQ.helpers.dateHelpers.getNewDateAddDays(PJQ.helpers.dateHelpers.getDateString(weekObj, PJQ.helpers.dateHelpers.dateFormats.DATE), 0),
            endDay = PJQ.helpers.dateHelpers.getNewDateAddDays(startDay, 6),
            options = this.model.get('options');
        options[0].value.from = startDay;
        options[0].value.to = endDay;

        // let isExportWorkLogs = this.$('.input-export-work-logs').prop('checked'),
        //     isExportNotes = this.$('.input-export-notes').prop('checked'),
        //     isExportExpenses = this.$('.input-export-expenses').prop('checked'),
        //     isExportSurvey = this.$('.input-export-survey').prop('checked'),
        //     isExportDeliveries = this.$('.input-export-deliveries').prop('checked'),
        //     isExportCommunications = this.$('.input-export-communications').prop('checked'),
        //     isExportInspections = this.$('.input-export-inspections').prop('checked'),
        //     isExportAttachments = this.$('.input-export-attachments').prop('checked'),
        //     isExportWeather = this.$('.input-export-weather').prop('checked'),

        if (typeof this.options.onDownload === 'function') {
            let loader = new PJQ.Loader(this.$('.modal-content'));
            this.options.onDownload(this.model.get('options'), _.bind(function () {
                loader.remove();
                this.removeModal();
            }, this));
        }
    }
});

PJQ.views.dailyReports.DailyReportLogDelaysModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DAILYREPORTS, 'modal-daily-report-log-delays'),
        maxWidth: 600,
        onSave: _.noop
    },
    events: {
        'click .btn-save': 'save',
        'click .btn-close': 'close'
    },
    renderData: function () {
        return {
            model: this.model
        };
    },
    afterRender: function () {
        new PJQ.Binder(this.$el, this.model, {
            watchElements: [
                'input',
                'textarea'
            ],
            afterChange: _.bind(function ($field) {
                if($field.hasClass('was-delayed')) {
                    this.render();
                }
            }, this)
        });
    },
    save: function () {
        if(!this.model.get('wasDelayed')) {
            this.model.set('delayReason', '');
        }

        this.$('.btn-save').attr('disabled', true);
        let loader = new PJQ.Loader(this.$('.modal-content'));
        this.model.updateDelay(() => {
            loader.remove()
            this.removeModal();
            if(typeof this.options.onSave === 'function') {
                this.options.onSave();
            }
        })
    },
    close: function() {
        this.model.restore();
        this.removeModal();
    }
});
